import { Directive, HostListener, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[detectCapslock]'
})
export class DetectCapslockDirective {

  parentComponent;

  constructor(private vcr: ViewContainerRef) {
    this.parentComponent = (<any>this.vcr.injector).view.component;
  }

  @HostListener('keypress', ['$event'])
    onKeyPress(e) {
      this.parentComponent.isCapslockOn = false;
      if (!+e.key && +e.key !== 0) {
        if (e.key === e.key.toUpperCase() && !e.shiftKey) {
          this.parentComponent.isCapslockOn = true;
        } else if (e.key === e.key.toLowerCase() && e.shiftKey) {
          this.parentComponent.isCapslockOn = true;
        }
      }
    }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/shared/detect-capslock.directive/detect-capslock.directive.ts